/* eslint-disable no-undef */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as telemedicinaActions from '../../../actions/telemedicinaActions';
// import TurnosSolicitudAlert from '../../../components/Telemedicina/TurnosSolicitudAlert/TurnosSolicitudAlert';
import TurnosEspontaneos from '../TurnosEspontaneos/TurnosEspontaneos';
// import IconCalendar from '../../../../public/images/agenda notif.png';

class AlertDisponibilidad extends Component {
  clickEspontaneo = () => {
    // this.props.espontaneoCall();
    this.props.validaciones();
    this.props.getTelefonoAfiliado();
  };

  // ALERT NEW DOC24
  alert = () => {
    let alert = '';
    if (this.props.showEspontaneos) {
      alert = (
        <TurnosEspontaneos
          // turno={this.props.espontaneo.hora}
          // especialidad={this.props.especialidad.especialidadOptions[1].text}
          press={() => this.clickEspontaneo()}
        />
      );
      // }else{
      //   alert=(null)
    }
    return alert;
  };

  // ALERT OLD
  // alert = () => {
  //   // const turnTime = moment(this.props.espontaneo.hora, 'hh:mm');
  //   // const endTime = moment('2045', 'hh:mm');
  //   // const firstTime = moment('0900', 'hh:mm');
  //   // const areTurnsAvailable =
  //   // turnTime.isSameOrAfter(firstTime) && turnTime.isBefore(endTime);
  //   console.log(this.props.especialidad && this.props.especialidad.especialidadOptions[1].text);
  //   let alert = '';
  //   if (this.props.alertTurnos === 1) {
  //     if (
  //       // areTurnsAvailable &&
  //       this.props.turnWaitingTime &&
  //       !this.props.turnWaitingTime.errorCode &&
  //       this.props.specialityName !== 'Well Test'
  //     ) {
  //       if (this.props.showEspontaneos) {
  //         alert = (
  //           <TurnosEspontaneos
  //             turno={this.props.espontaneo.hora}
  //             especialidad={this.props.especialidad.especialidadOptions[1].text}
  //             press={() => this.clickEspontaneo()}
  //           />
  //         );
  //       } else {
  //         // alert = (
  //         //   <TurnosSolicitudAlert alertType="success">
  //         //     <img
  //         //       alt="Anterior"
  //         //       src={IconCalendar}
  //         //       style={{ width: '30px', marginRight: '34px' }}
  //         //     />
  //         //     <span>
  //         //       Al tener un programado pedido no podrás acceder a los turnos
  //         //       espontáneos.
  //         //     </span>
  //         //   </TurnosSolicitudAlert>
  //         // );
  //       }
  //     } else {
  //       alert = (
  //         <TurnosSolicitudAlert alertType="success">
  //           <img
  //             alt="Anterior"
  //             src={IconCalendar}
  //             style={{ width: '30px', marginRight: '34px' }}
  //           />
  //           <span>En este momento no hay médicos disponibles.</span>
  //         </TurnosSolicitudAlert>
  //       );
  //     }
  //   } else if (this.props.alertTurnos === 2) {
  //     alert = (
  //       <TurnosSolicitudAlert alertType="warning">
  //         <i
  //           className="fa fa-exclamation-circle"
  //           aria-hidden="true"
  //           style={{
  //             color: '#FF7D00',
  //             fontSize: '20px',
  //             marginRight: '34px',
  //           }}
  //         />
  //         <span>En este momento no hay médicos disponibles.</span>
  //       </TurnosSolicitudAlert>
  //     );
  //   } else if (this.props.alertTurnos === 3) {
  //     alert = (
  //       <TurnosSolicitudAlert alertType="success">
  //         <img
  //           alt="Anterior"
  //           src={IconCalendar}
  //           style={{ width: '30px', marginRight: '34px' }}
  //         />
  //         <span>En este momento no hay médicos disponibles.</span>
  //       </TurnosSolicitudAlert>
  //     );
  //   }
  //   return alert;
  // };

  render() {
    return <div>{this.alert()}</div>;
  }
}

const mapStateToProps = state => ({
  turnWaitingTime: state.telemedicina.turnWaitingTime,
  stateEspecialidades: state.telemedicina.stateEspecialidades,
  stateMotivo: state.telemedicina.stateMotivo,
});

AlertDisponibilidad.propTypes = {
  showEspontaneos: PropTypes.bool.isRequired,
  // espontaneoCall: PropTypes.func.isRequired,
  validaciones: PropTypes.func.isRequired,
  getTelefonoAfiliado: PropTypes.func.isRequired,
  // alertTurnos: PropTypes.number.isRequired,
  // espontaneo: PropTypes.objectOf(PropTypes.any).isRequired,
  // especialidad: PropTypes.objectOf(PropTypes.any).isRequired,
  // specialityName: PropTypes.string.isRequired,
  // turnWaitingTime: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default connect(mapStateToProps, telemedicinaActions)(
  AlertDisponibilidad,
);



// WEBPACK FOOTER //
// ./src/components/Telemedicina/AlertDisponibilidad/AlertDisponibilidad.js